/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentContractuelProduitDto } from './DocumentContractuelProduitDto';
import {
    DocumentContractuelProduitDtoFromJSON,
    DocumentContractuelProduitDtoFromJSONTyped,
    DocumentContractuelProduitDtoToJSON,
    DocumentContractuelProduitDtoToJSONTyped,
} from './DocumentContractuelProduitDto';

/**
 * 
 * @export
 * @interface GetDocumentsContractuelsProduitResponse
 */
export interface GetDocumentsContractuelsProduitResponse {
    /**
     * 
     * @type {Array<DocumentContractuelProduitDto>}
     * @memberof GetDocumentsContractuelsProduitResponse
     */
    items: Array<DocumentContractuelProduitDto>;
}

/**
 * Check if a given object implements the GetDocumentsContractuelsProduitResponse interface.
 */
export function instanceOfGetDocumentsContractuelsProduitResponse(value: object): value is GetDocumentsContractuelsProduitResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetDocumentsContractuelsProduitResponseFromJSON(json: any): GetDocumentsContractuelsProduitResponse {
    return GetDocumentsContractuelsProduitResponseFromJSONTyped(json, false);
}

export function GetDocumentsContractuelsProduitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentsContractuelsProduitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DocumentContractuelProduitDtoFromJSON)),
    };
}

export function GetDocumentsContractuelsProduitResponseToJSON(json: any): GetDocumentsContractuelsProduitResponse {
    return GetDocumentsContractuelsProduitResponseToJSONTyped(json, false);
}

export function GetDocumentsContractuelsProduitResponseToJSONTyped(value?: GetDocumentsContractuelsProduitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DocumentContractuelProduitDtoToJSON)),
    };
}

